import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../reducers'
import { loadProjectDetails } from '../actions/project'

interface IProjectCapabilities {
  canGrantAccess?: boolean
}

interface IProjectDetailsData {
  id?: string
}

const useProjectAccess = (projectId: string) => {
  const dispatch = useDispatch()
  const capabilities = useTypedSelector(
    state => state.project?.details?.capabilities as IProjectCapabilities | null
  )
  const loadedId = useTypedSelector(
    state => (state.project?.details?.data as IProjectDetailsData | null)?.id
  )

  useEffect(() => {
    if (loadedId !== projectId) {
      dispatch(loadProjectDetails(projectId))
    }
  }, [dispatch, projectId, loadedId])

  return {
    canGrantAccess: capabilities?.canGrantAccess ?? false,
    loaded: loadedId === projectId
  }
}

export default useProjectAccess
